import VersionOptions from './VersionOptions';
import './VersionOptions.scss';

export default VersionOptions;
